export default "__VITE_PUBLIC_ASSET__6a6df35f__"